module.exports = __webpack_public_path__ + "media/images/new-menu-button-28ac1803.png";